<template>
    <div class="operation-manage">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>操作记录管理</span>
            </div>

            <!-- 用户最后登录时间查询 -->
            <div class="query-section">
                <div class="section-header">
                    <h3>全用户操作记录总览</h3>
                    <el-button type="primary" @click="fetchLastLogin" :loading="lastLoginLoading">
                        刷新
                    </el-button>
                </div>
                
                <el-table :data="lastLoginList" style="width: 100%; margin-top: 20px" v-loading="lastLoginLoading" border stripe>
                    <!-- <el-table-column prop="id" label="记录ID" width="80" align="center">
                    </el-table-column> -->
                                    <el-table-column type="index" label="序号" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (scope.$index + 1) }}
                    </template>
                </el-table-column>
                    <el-table-column prop="userId" label="用户ID" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="userName" label="用户名" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="module" label="操作模块" width="200" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="operationType" label="操作类型" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="getOperationTypeTag(scope.row.operationType)" size="small">
                                {{ scope.row.operationType }}
                            </el-tag>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="description" label="操作描述" align="center">
                        <template slot-scope="scope">
                            <div class="content-preview">
                                {{ scope.row.description || '无' }}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="method" label="方法名" width="200" align="center">
                        <template slot-scope="scope">
                            <div class="method-preview">
                                {{ scope.row.method || '无' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="params" label="参数" width="150" align="center">
                        <template slot-scope="scope">
                            <div class="params-preview">
                                {{ scope.row.params ? scope.row.params.substring(0, 20) + (scope.row.params.length > 20 ? '...' : '') : '无' }}
                            </div>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="ip" label="IP地址" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="operationTime" label="操作时间" width="220" align="center">
                        <template slot-scope="scope">
                            <span>{{ formatDateTime(scope.row.operationTime) }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="result" label="结果" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.result === 1 ? 'success' : 'danger'" size="small">
                                {{ scope.row.result === 1 ? '成功' : '失败' }}
                            </el-tag>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="executionTime" label="执行时间(ms)" width="120" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.executionTime || 0 }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="详情" width="120" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="viewUserOperations(scope.row.userId)">
                                查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="pagination-container">
                    <el-pagination
                        @size-change="handleLastLoginSizeChange"
                        @current-change="handleLastLoginCurrentChange"
                        :current-page="lastLoginPagination.currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="lastLoginPagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="lastLoginPagination.total">
                    </el-pagination>
                </div>
            </div>

            <!-- 用户操作记录查询 -->
            <div class="query-section" style="margin-top: 40px;">
                <div class="section-header">
                    <h3>单用户操作记录查询</h3>
                </div>
                
                <!-- 搜索区域 -->
                <div class="search-area">
                    <el-input v-model="userIdSearch" placeholder="请输入用户ID" style="width: 300px; margin-right: 10px"
                        clearable @keyup.enter.native="searchUserOperations">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="searchUserOperations" :loading="userOperationsLoading">
                        查询
                    </el-button>
                    <el-button @click="resetUserOperationsSearch">重置</el-button>
                </div>

                <el-table :data="userOperationsList" style="width: 100%; margin-top: 20px" v-loading="userOperationsLoading" border stripe>
                    <!-- <el-table-column prop="id" label="记录ID" width="80" align="center">
                    </el-table-column> -->
                                    <el-table-column type="index" label="序号" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (scope.$index + 1) }}
                    </template>
                </el-table-column>
                    <el-table-column prop="userId" label="用户ID" width="220" align="center">
                    </el-table-column>
                    <el-table-column prop="userName" label="用户名" width="220" align="center">
                    </el-table-column>
                    <el-table-column prop="module" label="操作模块" width="220" align="center">
                    </el-table-column>
                    <!-- <el-table-column prop="operationType" label="操作类型" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="getOperationTypeTag(scope.row.operationType)" size="small">
                                {{ scope.row.operationType }}
                            </el-tag>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="description" label="操作描述" align="center">
                        <template slot-scope="scope">
                            <div class="content-preview">
                                {{ scope.row.description || '无' }}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="method" label="方法名" width="200" align="center">
                        <template slot-scope="scope">
                            <div class="method-preview">
                                {{ scope.row.method || '无' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="params" label="参数" width="150" align="center">
                        <template slot-scope="scope">
                            <div class="params-preview">
                                {{ scope.row.params ? scope.row.params.substring(0, 20) + (scope.row.params.length > 20 ? '...' : '') : '无' }}
                            </div>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="ip" label="IP地址" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="operationTime" label="操作时间" width="220" align="center">
                        <template slot-scope="scope">
                            <span>{{ formatDateTime(scope.row.operationTime) }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="result" label="结果" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.result === 1 ? 'success' : 'danger'" size="small">
                                {{ scope.row.result === 1 ? '成功' : '失败' }}
                            </el-tag>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="executionTime" label="执行时间(ms)" width="120" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.executionTime || 0 }}</span>
                        </template>
                    </el-table-column> -->
                </el-table>

                <!-- 分页 -->
                <div class="pagination-container">
                    <el-pagination
                        @size-change="handleUserOperationsSizeChange"
                        @current-change="handleUserOperationsCurrentChange"
                        :current-page="userOperationsPagination.currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="userOperationsPagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="userOperationsPagination.total">
                    </el-pagination>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'OperationManage',
    data() {
        return {
            // 用户最后登录时间数据
            lastLoginList: [],
            lastLoginLoading: false,
            lastLoginPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            
            // 用户操作记录查询数据
            userIdSearch: '',
            userOperationsList: [],
            userOperationsLoading: false,
            userOperationsPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            
            // 操作类型标签映射
            operationTypeTagMap: {
                'QUERY': 'primary',
                'INSERT': 'success',
                'UPDATE': 'warning',
                'DELETE': 'danger',
                'OTHER': 'info',
                'LOGIN': 'success',
                'LOGOUT': 'info',
                'UPLOAD': 'primary',
                'DOWNLOAD': 'success'
            }
        }
    },
    created() {
        this.fetchLastLogin()
    },
    methods: {
        // API调用：查询用户最后登录时间
        async fetchLastLogin() {
            this.lastLoginLoading = true
            try {
                const params = {
                    currPage: this.lastLoginPagination.currentPage,
                    pageSize: this.lastLoginPagination.pageSize
                }
                
                const response = await this.$axios.get('/web/operation/queryLastOperation', { params })
                console.log('查询用户操作记录响应:', response.data)

                if (response.data) {
                    this.lastLoginList = response.data.list || []
                    this.lastLoginPagination.total = response.data.total || 0
                } else {
                    this.$message.error('查询用户操作记录失败')
                }
            } catch (error) {
                console.error('查询用户操作记录失败:', error)
                this.$message.error('查询用户操作记录失败')
            } finally {
                this.lastLoginLoading = false
            }
        },

        // API调用：根据用户ID查询操作记录
        async fetchUserOperations() {
            if (!this.userIdSearch.trim()) {
                this.$message.warning('请输入用户ID')
                return
            }
            
            this.userOperationsLoading = true
            try {
                const params = {
                    userId: this.userIdSearch,
                    currPage: this.userOperationsPagination.currentPage,
                    pageSize: this.userOperationsPagination.pageSize
                }
                
                const response = await this.$axios.post('/web/operation/queryByUserId', null, { params })
                console.log('查询用户操作记录响应:', response.data)

                if (response.data) {
                    this.userOperationsList = response.data.list || []
                    this.userOperationsPagination.total = response.data.total || 0
                } else {
                    this.$message.error('查询用户操作记录失败')
                }
            } catch (error) {
                console.error('查询用户操作记录失败:', error)
                this.$message.error('查询用户操作记录失败')
            } finally {
                this.userOperationsLoading = false
            }
        },

        // 获取操作类型标签样式
        getOperationTypeTag(type) {
            return this.operationTypeTagMap[type] || 'info'
        },

        // 格式化日期时间
        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return '无'
            
            try {
                // 处理 ISO 8601 格式的时间字符串（如：2026-01-21T08:42:35）
                const date = new Date(dateTimeStr)
                
                // 检查日期是否有效
                if (isNaN(date.getTime())) {
                    return dateTimeStr // 如果无法解析，返回原始字符串
                }
                
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const day = String(date.getDate()).padStart(2, '0')
                const hours = String(date.getHours()).padStart(2, '0')
                const minutes = String(date.getMinutes()).padStart(2, '0')
                const seconds = String(date.getSeconds()).padStart(2, '0')
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            } catch (error) {
                console.error('格式化日期时间失败:', error, dateTimeStr)
                return dateTimeStr // 如果出错，返回原始字符串
            }
        },

        // 查看用户所有操作记录
        viewUserOperations(userId) {
            this.userIdSearch = userId
            this.userOperationsPagination.currentPage = 1
            this.fetchUserOperations()
        },

        // 搜索用户操作记录
        searchUserOperations() {
            this.userOperationsPagination.currentPage = 1
            this.fetchUserOperations()
        },

        // 重置用户操作记录搜索
        resetUserOperationsSearch() {
            this.userIdSearch = ''
            this.userOperationsList = []
            this.userOperationsPagination.currentPage = 1
            this.userOperationsPagination.total = 0
        },

        // 用户最后登录时间分页大小改变
        handleLastLoginSizeChange(val) {
            this.lastLoginPagination.pageSize = val
            this.lastLoginPagination.currentPage = 1
            this.fetchLastLogin()
        },

        // 用户最后登录时间当前页改变
        handleLastLoginCurrentChange(val) {
            this.lastLoginPagination.currentPage = val
            this.fetchLastLogin()
        },

        // 用户操作记录分页大小改变
        handleUserOperationsSizeChange(val) {
            this.userOperationsPagination.pageSize = val
            this.userOperationsPagination.currentPage = 1
            this.fetchUserOperations()
        },

        // 用户操作记录当前页改变
        handleUserOperationsCurrentChange(val) {
            this.userOperationsPagination.currentPage = val
            this.fetchUserOperations()
        }
    }
}
</script>

<style scoped>
.operation-manage {
    padding: 20px;
}

.box-card {
    min-height: calc(100vh - 100px);
}

.query-section {
    margin-bottom: 30px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.section-header h3 {
    margin: 0;
    color: #303133;
    font-size: 18px;
    font-weight: 600;
}

.search-area {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-table {
    margin-top: 20px;
}

.el-button+.el-button {
    margin-left: 10px;
}

.content-preview {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.method-preview {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Courier New', monospace;
    font-size: 12px;
}

.params-preview {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Courier New', monospace;
    font-size: 12px;
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}
</style>